import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import withAuth from "../components/withAuth";
import ProfileInfos from "../components/dashboard/ProfileInfos";
import ProfileReceived from "../components/dashboard/ProfileReceived";
import ButtonPrimary from "../components/Button-primary";
import ButtonSecondary from "../components/Button-secondary";
import { useAuth } from "../contexts/AuthContext";

const Dashboard = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  console.log("userData", userData)

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "profile";

  const [tab, setTab] = useState(initialTab);

  useEffect(() => {
    const searchParams = new URLSearchParams({ tab });
    navigate({ search: searchParams.toString() });
  }, [tab, navigate]);

  return (
    <div className="flex flex-col gap-y-8 md:gap-y-0">
      <h1 className="flex justify-center text-[3rem] font-bold">Dashboard</h1>
      <div className="flex justify-center pt-4 gap-x-4">
        {tab === "profile" ? (
          <>
            <ButtonPrimary text={"Profile"} func={() => setTab("profile")} className="bg-blue-800" />
            <ButtonSecondary text={"Received"} func={() => setTab("received")} />
          </>
        ) : (
          <>
            <ButtonSecondary text={"Profile"} func={() => setTab("profile")} />
            <ButtonPrimary text={"Received"} func={() => setTab("received")} className="bg-blue-800" />
          </>
        )}
      </div>
      {tab === "profile" && <ProfileInfos userData={userData} />}
      {/* {tab === "portfolio" && <ProfileReceived />} */}
      {tab === "received" && <ProfileReceived userData={userData} />}
    </div>
  );
};

export default withAuth(Dashboard);
